import videoUtils from '../fsUtils/videoUtils';

/**
 * This class in in charge of loading a video sidebar player
 */
class TopVideos {
    constructor() {
        this.videos = document.querySelectorAll('.right-rail .top-videos-link');
        this.videoPlayerDiv = document.querySelector('.top-videos-playlist .video-player');
        this.addClickListeners();
        this.playerDivTag = null;
        this.sidebarPlayer = null;
    }

    addClickListeners() {
        if (this.videos) {
            for (let k = 0, j = this.videos.length; k < j; k++) {
                let video = this.videos[k];
                //add click listerner for the links
                video.addEventListener('click', (e) => {
                    (e.preventDefault) ? e.preventDefault(): (e.returnValue = false); //ie support

                    let pageName = (window.utag_data) ? window.utag_data.page_name : '';
                    let releaseUrl = video.getAttribute('release-url');
                    let category = video.getAttribute('category');
                    let endcardFeed = video.getAttribute('endcard-feed-url');
                    let currentUrl = video.getAttribute('current_url');
                    let videoPlatformDiv = video.parentNode.parentNode.children[1].children[0]; //video player div
                    this.videoPlayerDiv = video.parentNode.parentNode.children[1]; // get the video player div from the link the user is clicking on
                    this.playerDivTag = this.videoPlayerDiv.getAttribute('id');

                    //remove any existing player created by this component
                    let players = window.fdmPlayer;
                    if (players) {
                        for (let i = 0, l = players.length; i < l; i++) {
                            let player = players[i];
                            if (player) {
                                if (this.playerDivTag === player.tag) {
                                    this.sidebarPlayer = player;
                                    break;
                                }
                            }
                        }
                    }

                    let videoEl = videoUtils.addVideoPlayerElement(releaseUrl, endcardFeed, currentUrl, category, pageName, this.playerDivTag); //create the video player div
                    if (this.videoPlayerDiv) {
                        this.videoPlayerDiv.classList.remove('hide');
                        if (videoPlatformDiv && this.sidebarPlayer) {
                            this.sidebarPlayer.setReleaseCall(releaseUrl);
                        } else {
                            //create pinning wrapper
                            let wrapperEl = videoUtils.createPinWrapperEl();
                            wrapperEl.firstElementChild.appendChild(videoEl);
                            this.videoPlayerDiv.appendChild(wrapperEl); //add video player div
                            videoUtils.videoLoader(window.criticalVideoLoader); //load video player
                        }

                    }
                });
            }
        }
    }

}

export default TopVideos;


// WEBPACK FOOTER //
// ./assets/components/sidebar/TopVideos.js